import React from 'react';

import LoadingOverlay from  '../LoadingOverlay';

const Container = (props) => {
    const [ state, setState ] = React.useState({
        isMobile: false,
    })

    React.useEffect(() => {
        window.addEventListener("resize", resize);

        resize();
    }, [])

    const resize = () => {
        const isMobile = (window.innerWidth <= 760);

        setState({ ...state, isMobile });
    }

    return (
        <div id={props.id || crypto.randomUUID()} className="container-fluid" style={{ marginTop: state.isMobile ? '50px' : undefined }}>
            {props.loading ? <LoadingOverlay/> : ''}

            {props.children}
        </div>
    );
};

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container/index.js